export enum MemberSetting {
  BirthdateNotification = 'BirthdateNotification',
  MarketingNotification = 'MarketingNotification',
  GdprConsent = 'GdprConsent',
  OnlineProfile = 'OnlineProfile',
  TransactionalNotification = 'TransactionalNotification',
  SmsNotification = 'SmsNotification',
}
